import { render, staticRenderFns } from "./DetailCryptoTransaction.vue?vue&type=template&id=4d9e9a9b&scoped=true"
import script from "./DetailCryptoTransaction.vue?vue&type=script&lang=js"
export * from "./DetailCryptoTransaction.vue?vue&type=script&lang=js"
import style0 from "./DetailCryptoTransaction.vue?vue&type=style&index=0&id=4d9e9a9b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d9e9a9b",
  null
  
)

export default component.exports